import { componentQrl, inlinedQrl, _jsxS, _fnSignal } from "@builder.io/qwik";
const SubmitButton = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxS("button", {
    ...props.attributes,
    children: _fnSignal((p0) => p0.text, [
      props
    ], "p0.text")
  }, {
    type: "submit"
  }, 0, "6z_0");
}, "SubmitButton_component_NXvMBMCDhwc"));
export {
  SubmitButton,
  SubmitButton as default
};
